<template>
  <b-form-group>
    <label class="idx-bold">{{
      $t('newAction.stepOne.labels.settingSMS')
    }}</label>
    <b-form-radio-group
      id="sms-radio-group"
      v-model="action.sms.config"
      :checked="action.sms.config"
    >
      <b-form-radio value="link">
        {{ $t('newAction.stepOne.searchLink') }}
      </b-form-radio>
      <b-form-radio value="body">
        {{ $t('newAction.stepOne.searchBody') }}
      </b-form-radio>
    </b-form-radio-group>
  </b-form-group>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  watch: {
    'action.sms.config': function watchActionSmsConfig(value) {
      this.setSmsConfig({ config: value });
      if (value === 'body') {
        this.$store.state.actions.switchQuestions = false;
        this.$store.state.actions.action.email.additionalQuestions = [];
      }
    },
  },
  methods: {
    ...mapActions('actions', ['setSmsConfig']),
  },
  computed: {
    ...mapState('actions', ['action']),
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/molecules/sms-config/index.vue